var _rect, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStoreFront(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.500092,
    width: 40,
    height: 40,
    rx: 15,
    fill: "#F8B400",
    fillOpacity: 0.15
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8318_5458)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23 13.4021L22.061 8.50009H24.004L26.998 13.5021V14.6001C26.998 15.6671 26.066 16.5001 25 16.5001C23.934 16.5001 23 15.5671 23 14.5001V13.4021ZM20 16.5001C21.066 16.5001 22 15.5641 22 14.4981V13.4001L20.953 8.50009H19.047L18 13.4021V14.5001C18 15.5671 18.934 16.5001 20 16.5001ZM28 14.5001C28 15.5671 28.934 16.5001 30 16.5001C31.066 16.5001 32 15.6351 32 14.5681V13.4711L27.127 8.50009H25.113L28 13.4021V14.5001ZM21 28.0001L21.025 27.5001H11V20.5001H29V21.6811C29.721 21.8521 30.395 22.1401 31 22.5291V18.5001H9V32.5001H22.816C21.693 31.3321 21 29.7481 21 28.0001ZM12 14.5681V13.4711L14.887 8.50009H12.873L8 13.4711V14.5691C8 15.6351 8.934 16.5001 10 16.5001C11.066 16.5001 12 15.6351 12 14.5681ZM13 14.5681C13 15.6351 13.934 16.5001 15 16.5001C16.066 16.5001 17 15.6351 17 14.5681V13.4711L17.939 8.50009H15.996L13 13.4711V14.5681ZM32 28.0001C32 30.4851 29.984 32.5001 27.5 32.5001C25.014 32.5001 23 30.4851 23 28.0001C23 25.5151 25.014 23.5001 27.5 23.5001C29.984 23.5001 32 25.5151 32 28.0001ZM29.844 27.1181L29.147 26.4221L27.032 28.5911L26.04 27.6511L25.345 28.3481L27.033 29.9851L29.844 27.1181Z",
    fill: "#028789"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8318_5458"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(8 8.50009)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStoreFront);
export default __webpack_public_path__ + "static/media/store_front.034a603848bb6273e681a3cc983823c1.svg";
export { ForwardRef as ReactComponent };